import 'slick-carousel/slick/slick';
import $ from "jquery";

class History {
    constructor() {
        
        console.log('History');

        $('.slider-content').slick({
            dots: false,
            arrows : false,
            infinite: true,
            asNavFor: '.slider-year',
            fade: true,
            speed: 450,
            slidesToShow: 1,            
        });


        $('.slider-year').slick({
            dots: false,
            
            infinite: true,
            asNavFor: '.slider-content',
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            focusOnSelect: true,
            speed: 200,
            prevArrow: $('.prev-arrow'),
            nextArrow: $('.next-arrow'),
        });
        
    }
}

export default History;